import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkInvAccess } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class InvRolesGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const currentUrl = state.url;
    const urlSegments = currentUrl.split('/').filter(Boolean);
    const lastSegment = urlSegments[urlSegments.length - 1];

    const invnavbarPermission = checkInvAccess();
    const accessInv = invnavbarPermission.screenAccess;

    let isVisible = false;

    switch (lastSegment) {
      case 'module-type':
        isVisible = accessInv.moduleType;
        break;
      case 'container-ordering':
        isVisible = accessInv.containerOrdering;
        break;
      case 'modulestocking':
        isVisible = accessInv.moduleStocking;
        break;
      case 'stocking-pace-maintenance':
        isVisible = accessInv.stockingPaceMaintenance;
        break;
      case 'productionprogress':
        isVisible = accessInv.productionProgress;
        break;
      case 'parts-count':
        isVisible = accessInv.partsCount;
        break;
      case 'stocking-pace-inquiry':
        isVisible = accessInv.stockingPaceInquiry;
        break;
      case 'usagevsreceipt':
        isVisible = accessInv.uvRGraph;
        break;
      case 'Procurement':
        isVisible = accessInv.procurement;
        break;
      case 'containertap':
        isVisible = accessInv.containerTap;
        break;
      case 'partsandinventorpolicies':
        isVisible = accessInv.partsAndInventoryPolicies;
        break;
      case 'devan-history':
        isVisible = accessInv.devanningHistory;
        break;
      case 'jobstatus':
        isVisible = accessInv.jobStatus;
        break;
      case 'reports':
        isVisible = accessInv.reports;
        break;
      default:
        break;
    }

    if (!isVisible) {
      this.router.navigate(['/dashboard']);
      return isVisible;
    }

    return isVisible;
  }
}
